<template>
	<div class="ModuleBoxLogin" v-if="Visible">
		<div class="ModuleBoxLoginBody">
			<div class="ModuleBoxLoginBodyTop">
				<div class="ModuleBoxLoginBodyTopLogo">
					<el-image :src="ImageLogoUrl" fit="scale-down" />
				</div>
				<div class="ModuleBoxLoginBodyTopCloseBtn" @click="onHide()">
					<el-icon><Close /></el-icon>
				</div>
			</div>
			<div class="ModuleBoxLoginBodyBody">
				<div class="ModuleBoxLoginBodyBodyBody">
					<el-form 
						:model="LoginForm" 
						:rules="LoginRules" 
						ref="LoginFormRef" 
						label-width="0"
					>
						<div class="ModuleBoxLoginBodyBodyBodyItem">
							<div class="ModuleBoxLoginBodyBodyBodyItemTitle">登录账号</div>
							<div class="ModuleBoxLoginBodyBodyBodyItemBody">
								<el-form-item prop="Username">
									<el-input v-model="LoginForm.Username" placeholder="请输入登录账号" />
								</el-form-item>
							</div>
						</div>
						<div class="ModuleBoxLoginBodyBodyBodyItem">
							<div class="ModuleBoxLoginBodyBodyBodyItemTitle">登录密码</div>
							<div class="ModuleBoxLoginBodyBodyBodyItemBody">
								<el-form-item prop="Password">
									<el-input type="password" v-model="LoginForm.Password" placeholder="请输入登录密码" />
								</el-form-item>
							</div>
						</div>
						<div class="ModuleBoxLoginBodyBodyBodyItem">
							<div class="ModuleBoxLoginBodyBodyBodyItemTitle">验证码</div>
							<div class="ModuleBoxLoginBodyBodyBodyItemBody" style="display: flex;">
								<el-form-item prop="Captcha" style="width: 100%;">
									<el-input v-model="LoginForm.Captcha" placeholder="请输入验证码" />
								</el-form-item>
								<div class="ModuleBoxLoginBodyBodyBodyItemBodyCaptcha" @click="ResetCaptcha()">
									<Sidentify ref="Captcha" :identifyCode="CaptchaValue"></Sidentify>
								</div>
							</div>
						</div>
						<div class="ModuleBoxLoginBodyBodyBodyPasswordTips">
							<div class="ModuleBoxLoginBodyBodyBodyPasswordTipsValue" @click="onResetPassword()">忘记密码</div>
						</div>
						<div class="ModuleBoxLoginBodyBodyBodyButton">
							<div class="ModuleBoxLoginBodyBodyBodyButtonLoginBtn" @click="LoginSubmit()">登录</div>
						</div>
						<div class="ModuleBoxLoginBodyBodyBodyBottom">
							还没有账号?<span @click="onRegister()">立即注册</span>
						</div>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>
